export default "__VITE_ASSET__9HMnqfei__"